import { useChatInputStore } from '@/store';
import { openNewChatComposer } from '@/lib/openHomeComposer';
import { blockIfWorkModeDisabled } from '@/lib/workModeAvailability';

/** Ideas open an editable draft. They never send a message or start paid work. */
export function openIdeaComposer(router, idea, prompt = idea?.prompt) {
  if (!prompt?.trim()) return false;
  const work = idea?.mode === 'work';
  if (work && blockIfWorkModeDisabled()) return false;
  useChatInputStore.getState().clearPendingAutoSend();
  openNewChatComposer(router, { work });
  useChatInputStore.getState().setText(prompt.trim());
  return true;
}
